import request from "./request";

export const http = {
  //列表
  aprchxList(params) {
    return request({
      method: "POST",
      url: "/platform/pc/order/apr-chx/list",
      data: params,
    });
  },
  //导出Excel
  aprchxExcel(params) {
    return request({
      method: "POST",
      url: "/platform/pc/order/apr-chx/excel",
      data: params,
      responseType: "blob",
    });
  },
  //Q-自动向外部提交渠道列表
  autoApplyChannelList(params) {
    return request({
      method: "GET",
      url: "/platform/pc/platform/channel/automaticConfigs",
      params,
    });
  },

    //分公司自动提交售后设置
  innerAutomaticConfigs(params) {
    return request({
      method: "GET",
      url: "/platform/pc/platform/channel/innerAutomaticConfigs",
      params,
    });
  },
  //启用-关闭 自动申请追差
  ocAutoApply(params) {
    return request({
      method: "POST",
      url: "/platform/pc/order/apr-chx/oc-auto-apply",
      data: params,
    });
  },
    //开启自动提交
  automaticSubmission(params) {
    return request({
      method: "POST",
      url: "/platform/pc/platform/channel/automaticSubmission",
      data: params,
    });
  },
  //Q-详情
  detail(params) {
    return request({
      method: "POST",
      url: "/platform/pc/order/apr-chx/detail",
      data: params,
    });
  },
  //发起申请
  apply(params) {
    return request({
      method: "POST",
      url: "/platform/pc/order/apr-chx/apply",
      data: params,
    });
  },
  //追差分类列表
  aprCatalogList(params) {
    return request({
      method: "POST",
      url: "/platform/pc/apr/catalog/list",
      data: params,
    });
  },
  //采货侠追差项
  down(params) {
    return request({
      method: "GET",
      url: "/platform/pc/apr/catalog/list/down",
      params: params,
    });
  },
  //平台追差项
  chxDownList(params) {
    return request({
      method: "GET",
      url: "/platform/pc/apr/catalog/out/chx_down_list",
      params: params,
    });
  },
  //移除待申请列表
  removeWaitApply(params) {
    return request({
      method: "POST",
      url: "/platform/pc/order/apr-chx/removeWaitApply",
      data: params,
    });
  },
         // Q-根据渠道标识查询上传视频或者照片的标识
    getFlagByOutType(params) {
        return request({
            method: 'GET',
            url: '/platform/pc/order/apr/getFlagByOutType',
            params,
        })
    },
};
